export default __webpack_public_path__ + "static/media/Cinema_location.c0590dfc.svg";